import { render, staticRenderFns } from "./orders-view.vue?vue&type=template&id=102780ee&scoped=true"
import script from "./orders-view.vue?vue&type=script&lang=js"
export * from "./orders-view.vue?vue&type=script&lang=js"
import style0 from "./orders-view.vue?vue&type=style&index=0&id=102780ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102780ee",
  null
  
)

export default component.exports